import { Alert } from '@mui/material';
import useNetworkStatus from '../hooks/useNetworkStatus';
import { runtime } from '../platform/runtime';

export default function OfflineBanner() {
    const connected = useNetworkStatus();
    if (!runtime.isNative() || connected !== false) return null;
    return <Alert severity="warning" role="status" sx={{ borderRadius: 0 }}>
        No internet connection
    </Alert>;
}
